import { fetchRecipes, fetchRecipesByIds } from '../api/dietApi';
import { getRecipeCatalogId, getRecipeName } from '../diet-plan/recipeId';

export const RECIPE_PAGE_LIMIT = 100;
export const RECIPE_SEARCH_MIN = 2;
export const RECIPE_SEARCH_DEBOUNCE_MS = 800;

const DEFAULT_SORT = { sortBy: 'diet_plan_usage_count', sortOrder: 'desc' };

function mapRow(row) {
  const id = getRecipeCatalogId(row);
  const name = getRecipeName(row);
  return {
    ...row,
    food_id: id,
    recipe_id: id,
    food_name: name,
    recipe_name: name,
    common_name: row.common_name || row.common_names || '',
  };
}

/**
 * Fetch recipes from Diet DB. Same call for list page, food picker, and ingredient search.
 */
export async function fetchRecipeList(eventTypeId, options = {}) {
  if (!eventTypeId) {
    return { success: false, message: 'Missing event type', recipes: [], totalCount: 0, hasMore: false };
  }

  const {
    search = null,
    offset = 0,
    limit = RECIPE_PAGE_LIMIT,
    sortBy = DEFAULT_SORT.sortBy,
    sortOrder = DEFAULT_SORT.sortOrder,
    filters = null,
  } = options;

  const res = await fetchRecipes(
    eventTypeId,
    limit,
    offset,
    search?.trim() || null,
    sortBy,
    sortOrder,
    filters,
    true
  );

  if (!res.success) {
    return {
      success: false,
      message: res.message || 'Failed to fetch recipes',
      recipes: [],
      totalCount: 0,
      hasMore: false,
    };
  }

  return {
    success: true,
    recipes: (res.data?.recipes || []).map(mapRow),
    totalCount: res.data?.total_count ?? 0,
    hasMore: res.data?.has_more ?? false,
  };
}

/** Batch full recipe details in one request; rows mapped via mapRow, keyed by String(id). */
export async function fetchRecipesByIdMap(eventTypeId, recipeIds) {
  const ids = [...new Set((recipeIds || []).filter(Boolean))];
  if (!eventTypeId || ids.length === 0) {
    return { success: false, message: 'Missing event type or recipe ids', recipesById: {} };
  }

  const res = await fetchRecipesByIds(eventTypeId, ids);
  if (!res.success) return { ...res, recipesById: {} };

  const recipesById = {};
  (res.data?.recipes || []).forEach((row) => {
    const mapped = mapRow(row);
    if (mapped.food_id) recipesById[String(mapped.food_id)] = mapped;
  });
  return { success: true, recipesById };
}
